import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from './models/api-response';
import { GenericItem } from './models/generic-item';
import { GenericList } from './models/generic-list';
import { SystemRestPlanDashboard } from './models/system-rest-plan-dashboard';
import { SystemRestPlanSetting } from './models/system-rest-plan-setting';
import { SystemRestPlanVehicle } from './models/system-rest-plan-vehicle';

import { ServicerProvider } from './servicer';

const BASE_URL = '/v2/system/restPlan';

/**
 * [システム] 休憩計画 のプロバイダー.
 */
@Injectable()
export class SystemRestPlanServiceProvider {

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * ダッシューボード情報を取得.
   *
   * @returns Observable<GenericItem<SystemRestPlanDashboard>>
   */
  getDashboard(): Observable<GenericItem<SystemRestPlanDashboard>> {
    const url = `${BASE_URL}/dashboard`;
    return this.servicer.get<GenericItem<SystemRestPlanDashboard>>(url);
  }

  /**
   * 設定情報を取得.
   * 
   * @returns Observable<SystemRestPlanSetting>
   */
  getSetting(): Observable<GenericItem<SystemRestPlanSetting>> {
    const url = `${BASE_URL}/setting`;
    return this.servicer.get<GenericItem<SystemRestPlanSetting>>(url);
  }

  /**
   * 設定情報更新.
   *
   * @param data 入力データ
   * @returns Observable<ApiResponse>
   */
  updateSetting(data: SystemRestPlanSetting): Observable<ApiResponse> {
    const url = `${BASE_URL}/setting`;
    return this.servicer.postApi<SystemRestPlanSetting, ApiResponse>(url, data);
  }


  /**
   * 車両情報を取得.
   * 
   * @returns Observable<SystemRestPlanVehicle>
   */
  getVehicles(): Observable<GenericList<SystemRestPlanVehicle>> {
    const url = `${BASE_URL}/vehicles`;
    return this.servicer.get<GenericList<SystemRestPlanVehicle>>(url);
  }

  /**
   * 車両情報更新.
   *
   * @param datas 入力データ
   * @returns Observable<ApiResponse>
   */
  updateVehicles(datas: SystemRestPlanVehicle[]): Observable<ApiResponse> {
    const url = `${BASE_URL}/vehicles`;
    return this.servicer.postApi<SystemRestPlanVehicle[], ApiResponse>(url, datas);
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-rest-plan-service.ts